import { createContainer } from 'react-sweet-state';

import {
  ACTIONS,
  type Actions,
  type ContainerProps,
  type State,
  TemplatesStore,
} from './TemplatesStore';

export const TemplatesStoreContainer = createContainer<State, Actions, ContainerProps>(
  TemplatesStore,
  {
    onInit:
      () =>
      ({ setState, dispatch }, { state }) => {
        dispatch(ACTIONS.init());

        if (state) {
          setState(state);
        }
      },
    onUpdate:
      () =>
      ({ setState }, { state }) => {
        if (state) {
          setState(state);
        }
      },
  }
);
